'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/shared/ui/shadcn/card';
import { Alert, AlertDescription } from '@/shared/ui/shadcn/alert';

// Temporary stub - analytics endpoint not implemented in API yet
export default function TokenUsageAnalytics() {
  const t = useTranslations('tokenUsageAnalytics');
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Alert>
          <AlertDescription>{t('comingSoon')}</AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
}
